// UI
import Button from 'react-scale/components/elements/button';
import AnchorArrow from 'react-scale/components/elements/anchor-arrow';
import CTA from 'react-scale/components/elements/cta';
import Card from 'react-scale/components/elements/card';
import Navigation from 'react-scale/components/elements/navigation';
import Section from 'react-scale/components/elements/section';
import SectionTitle from 'react-scale/components/elements/section-title';
import Box from 'react-scale/components/elements/box';
import Header from 'react-scale/components/elements/header';
import Footer from 'react-scale/components/elements/footer';
import LogoGrid from 'react-scale/components/elements/logo-grid';
import SceneViewer from 'react-scale/components/elements/scene-viewer';
import Tooltip from 'react-scale/components/elements/tooltip';
import DataSlider from 'react-scale/components/elements/data-slider';
import VideoGallery from 'react-scale/components/elements/video-gallery';
import Quote from 'react-scale/components/elements/quote'; // Remove this Quote after publish Builder
import Video from 'react-scale/components/elements/video';
import Feature from 'react-scale/components/elements/new-features';
import QuoteUI from 'react-scale/components/elements/quote-ui'; // Replace for Quote after publish Builder
import SimpleForm from 'react-scale/components/elements/simple-form';
import HubspotForm from 'react-scale/components/elements/hubspot-form';

// Sections
import BrandPanelWithScreenshot from 'react-scale/components/sections/cta/brand-panel-with-screenshot';
import CTASimpleCentered from 'react-scale/components/sections/cta/simple-centered';
import QualityAssurance from 'react-scale/components/sections/quality-assurance';
import EnterpriseReady from 'react-scale/components/sections/enterprise-ready';
import HeroBigWebGL from 'react-scale/components/sections/hero/big-webgl';
import HeroImageOnRight from 'react-scale/components/sections/hero/image-on-right';
import HeroSimpleLeft from 'react-scale/components/sections/hero/simple-left';
import HeroSimpleCentered from 'react-scale/components/sections/hero/simple-centered';
import LogoGridSection from 'react-scale/components/sections/logo-cloud/grid';
import HeroDefault from 'react-scale/components/sections/hero/hero-default';

export {
  AnchorArrow,
  Button,
  Box,
  Card,
  CTA,
  Navigation,
  BrandPanelWithScreenshot,
  SectionTitle,
  Header,
  Footer,
  Section,
  LogoGrid,
  SceneViewer,
  CTASimpleCentered,
  QualityAssurance,
  EnterpriseReady,
  HubspotForm,
  HeroSimpleLeft,
  HeroBigWebGL,
  HeroImageOnRight,
  HeroSimpleCentered,
  Tooltip,
  DataSlider,
  LogoGridSection,
  VideoGallery,
  Quote,
  Video,
  Feature,
  QuoteUI,
  HeroDefault,
  SimpleForm
};
